import React from 'react'
import { SelectAnimalFetchInput } from 'src/components'
import { useStyles } from '../../styles'
import { filterAnimalsByReproductionAge } from '../../../utils/functions'

interface AnimalSelectionSectionProps {
  selectedAnimalId?: string
  error?: string
  onSelectAnimal: (animalId: string) => void
}

export const AnimalSelectionSection: React.FC<AnimalSelectionSectionProps> = ({
  selectedAnimalId,
  error,
  onSelectAnimal
}) => {
  const style = useStyles()

  return (
    <section className={style.section}>
      <div className={style.formControl}>
        <SelectAnimalFetchInput
          label='Vaca'
          selectBy='id'
          showBy={['cdn', 'nome']}
          filteredSex='Fêmea'
          filter={filterAnimalsByReproductionAge}
          value={selectedAnimalId || ''}
          error={error}
          placeholder='Selecionar vaca'
          onChange={(item: any) => {
            onSelectAnimal(item?.id || '')
          }}
        />
      </div>
    </section>
  )
}
